import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { DropdownModule } from '../../shared/directives/dropdown/dropdown.module';
import { NavigationModalModule } from '../navigation-modal/navigation-modal.module';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    DropdownModule,
    NavigationModalModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class HeaderModule { }
